module.exports = __webpack_public_path__ + "static/image/promotion-keyboard.svg?4dcf23a0430154a9ac9027b0c1416a5f";